module.exports = __webpack_public_path__ + "media/bootstrap-icons/image-fill-5b828ec2.svg";